import i18n from '@dms/i18n';

import {EMPTY_PLACEHOLDER, isValidEmail, Nullish} from 'shared/web';

/**
 * True for a stored e-mail that the DMS API refuses. An empty e-mail, the placeholder and the
 * "no e-mail" text are not invalid, and spaces around the e-mail do not count because the forms trim them on save.
 */
export const isInvalidEmail = (email: string | Nullish) => {
  const trimmedEmail = (email ?? '').trim();

  return (
    trimmedEmail !== '' &&
    trimmedEmail !== EMPTY_PLACEHOLDER &&
    trimmedEmail !== i18n.t('entity.customer.labels.noEmail') &&
    !isValidEmail(trimmedEmail)
  );
};
